/* eslint-disable */
import React, { Component } from 'react';
import { t } from './i18n';

// กิจกรรม/ทัวร์นาเมนต์ (static) — แก้/เพิ่มได้ที่นี่
const EVENTS = [
  { icon: '🏆', tag: 'TOURNAMENT', tagColor: '#e8821e', title: 'ทัวร์นาเมนต์สล็อตประจำสัปดาห์', desc: 'แข่งทำยอดเทิร์นสล็อตสูงสุด ลุ้นเงินรางวัลรวม 100,000 บาท', prize: 'รวม 100,000฿', period: 'ทุกสัปดาห์ จ-อา' },
  { icon: '🔥', tag: 'HOT', tagColor: '#c10655', title: 'แข่งยอดเสีย คืนสูงสุด 10%', desc: 'ยิ่งเล่นยิ่งคืน คืนยอดเสียอัตโนมัติทุกวันอาทิตย์ ถอนได้ไม่ต้องเทิร์น', prize: 'คืนสูงสุด 10%', period: 'คำนวณทุกอาทิตย์' },
  { icon: '🎁', tag: 'DAILY', tagColor: '#7b2ff7', title: 'เช็คอินรับเครดิตฟรีทุกวัน', desc: 'เข้าเว็บเช็คอินต่อเนื่องรับเครดิตฟรีเพิ่มขึ้นทุกวัน ครบ 7 วันรับโบนัสใหญ่', prize: 'ฟรีทุกวัน', period: 'ทุกวัน' },
  { icon: '👥', tag: 'AFFILIATE', tagColor: '#0f9d58', title: 'ชวนเพื่อนรับค่าแนะนำตลอดชีพ', desc: 'แชร์ลิงก์ชวนเพื่อน รับส่วนแบ่งจากยอดเล่นของเพื่อนทุกครั้ง ไม่มีวันหมดอายุ', prize: 'สูงสุด 0.35%', period: 'ตลอดชีพ' },
  { icon: '🎡', tag: 'WHEEL', tagColor: '#1565c0', title: 'กงล้อนำโชค ลุ้นเงินรางวัล', desc: 'เติมเงินครบเงื่อนไขรับสิทธิ์หมุนกงล้อ ลุ้นรางวัลใหญ่กว่า 9,999 บาท', prize: 'สูงสุด 9,999฿', period: 'ทุกวัน' },
];

class Event extends Component {
  get lang() { return localStorage.getItem('lang') || 'th'; }

  render() {
    const lang = this.lang;
    return (
      <div className="container p-0 x-margin-top-v3">
        <div className="row m-0 border-shadow-title">
          <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
            <div className="text-center bg-title-web">
              <div className="text-title text-white-v1 text-center">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <a role="button" href="/" style={{ cursor: 'pointer' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                    </svg>
                  </a>
                  <h5 className="m-0">{t(lang, 'event_title')}</h5>
                  <div style={{ width: 25 }} />
                </div>
                <hr className="mt-0" />
              </div>
            </div>

            <div className="p-2 bg-profile-box-overview animated animatedFadeInUp fadeInUp">
              {/* Hero */}
              <div style={{
                background: 'radial-gradient(120% 120% at 50% 0%, #ff82b6 0%, #c10655 70%, #7a0540 100%)',
                borderRadius: 16, padding: '18px 16px', marginBottom: 14, textAlign: 'center',
                boxShadow: '0 8px 24px rgba(193,6,85,0.35)', position: 'relative', overflow: 'hidden',
              }}>
                <div style={{ fontSize: 34 }}>🏆</div>
                <div style={{ color: '#fff', fontWeight: 800, fontSize: 18, marginTop: 2 }}>{t(lang, 'event_hero_title')}</div>
                <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 12, marginTop: 4 }}>{t(lang, 'event_hero_sub')}</div>
              </div>

              {EVENTS.map((e, i) => (
                <div key={i} style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 14, padding: '14px', marginBottom: 10,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{
                      width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                      background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.12)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26,
                    }}>{e.icon}</div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <span style={{
                        display: 'inline-block', background: e.tagColor, color: '#fff',
                        fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, marginBottom: 4,
                      }}>{e.tag}</span>
                      <div style={{ color: '#fff', fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>{e.title}</div>
                    </div>
                  </div>
                  <div style={{ color: 'rgba(255,255,255,0.72)', fontSize: 12.5, lineHeight: 1.6, marginTop: 8 }}>{e.desc}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, gap: 8 }}>
                    <span style={{ color: '#ffb3d4', fontSize: 11 }}>📅 {e.period}</span>
                    <span style={{
                      background: 'rgba(255,130,182,0.15)', border: '1px solid rgba(255,130,182,0.4)',
                      color: '#ffb3d4', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 8,
                    }}>{e.prize}</span>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Event;
